import { Action, createReducer, on } from '@ngrx/store';
import * as AccessManagementActions from './access-management.actions';
import { AccessManagementState } from './access-management.models';

export const ACCESS_MANAGEMENT_FEATURE_KEY = 'accessManagement';

export const initialAccessManagementState: AccessManagementState = {
  selectedTabIndex: 0,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialAccessManagementState,
  on(AccessManagementActions.initAccessManagement, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(AccessManagementActions.setSelectedTab, (state, { tabIndex }) => ({
    ...state,
    selectedTabIndex: tabIndex,
  })),
  on(AccessManagementActions.loadAccessManagementSuccess, (state) => ({
    ...state,
    loaded: true,
  })),
  on(AccessManagementActions.loadAccessManagementFailure, (state, { error }) => ({
    ...state,
    error: error instanceof Error ? error.message : String(error),
  }))
);

export function accessManagementReducer(state: AccessManagementState | undefined, action: Action) {
  return reducer(state, action);
}